import { useCallback } from 'react';
import { useTranslation } from 'react-i18next';
import type { ComponentType } from 'react';
import {
  SplitIcon,
  ChartLineIcon,
  BoxIcon,
  CalendarDaysIcon,
  RotateCwIcon,
  CalendarHeartIcon,
  StoreIcon,
} from 'lucide-react';
import { ModuleNames } from '@/app/shared/module-names';

import allocations from '../../../app/assets/module-icons/allocations.svg';
import inventory from '../../../app/assets/module-icons/inventory.svg';
import planningAssistant from '../../../app/assets/module-icons/planning-assistant.svg';
import replenishment from '../../../app/assets/module-icons/replenishment.svg';
import specialEvents from '../../../app/assets/module-icons/special-events.svg';
import storeTransfer from '../../../app/assets/module-icons/store-transfer.svg';
import analytics from '../../../app/assets/module-icons/analytics.svg';

export const moduleIconsSvg: Record<ModuleNames, string | null> = {
  [ModuleNames.Allocations]: allocations,
  [ModuleNames.Analytics]: analytics,
  [ModuleNames.Inventory]: inventory,
  [ModuleNames.Replenishment]: replenishment,
  [ModuleNames.SpecialEvents]: specialEvents,
  [ModuleNames.StoreTransfer]: storeTransfer,
  [ModuleNames.PlanningAssistant]: planningAssistant,
  [ModuleNames.DataCenter]: null,
};

export const moduleIcons: Record<ModuleNames, ComponentType | null> = {
  [ModuleNames.Allocations]: SplitIcon,
  [ModuleNames.Analytics]: ChartLineIcon,
  [ModuleNames.Inventory]: BoxIcon,
  [ModuleNames.PlanningAssistant]: CalendarDaysIcon,
  [ModuleNames.Replenishment]: RotateCwIcon,
  [ModuleNames.SpecialEvents]: CalendarHeartIcon,
  [ModuleNames.StoreTransfer]: StoreIcon,
  [ModuleNames.DataCenter]: null,
};

function moduleNameToModulesKey(moduleName: ModuleNames): string {
  return moduleName.charAt(0).toLowerCase() + moduleName.slice(1);
}

/** Localized module label from the `modules` i18n namespace (react-i18next). */
export function useModuleDisplayName(): (moduleName: ModuleNames) => string {
  const { t } = useTranslation('modules');
  return useCallback(
    (moduleName: ModuleNames) => t(moduleNameToModulesKey(moduleName)) || String(moduleName),
    [t],
  );
}
